import type { PropsWithChildren } from 'react';

import { PlusCircleFilled } from '@ant-design/icons';
import { SkyButton } from './SkyButton';
import { Grid } from 'antd';

const { useBreakpoint } = Grid;

interface SkyListyActionButtonProps extends PropsWithChildren<{}> {
  onClick: () => void;
  isTitleVisible?: boolean;
}

/**
 * Component for a list action button with optional title visibility.
 * Uses Ant Design's Grid system for responsive behavior.
 */
export const SkyListyActionButton = ({
  onClick,
  children,
  isTitleVisible = false,
}: SkyListyActionButtonProps) => {
  const screens = useBreakpoint();
  const showLabel = isTitleVisible || !!screens.md;
  const ariaLabel = typeof children === 'string' && children.trim() ? children : 'add new item';

  return (
    <SkyButton
      size="middle"
      icon={<PlusCircleFilled className="mr-0 md:mr-1" />}
      type="default"
      onClick={onClick}
      aria-label={ariaLabel}
    >
      {showLabel ? children : null}
    </SkyButton>
  );
};
